import { render, staticRenderFns } from "./FreeReadPopup.vue?vue&type=template&id=6995735c&scoped=true"
import script from "./FreeReadPopup.vue?vue&type=script&lang=js"
export * from "./FreeReadPopup.vue?vue&type=script&lang=js"
import style0 from "./FreeReadPopup.vue?vue&type=style&index=0&id=6995735c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6995735c",
  null
  
)

export default component.exports